import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query'
import { getLocalStorageItem } from '../utils/local-storage.ts'
import notification from 'antd/es/notification/index'

export function getBaseUrl(interfaceName: string): string {
  const endpoint = getIdeyaBaseUrl()
  return endpoint + interfaceName
}

export function getIdeyaBaseUrl(): string {
  const ideyaApiUrl = import.meta.env.VITE_IDEYA_API_URL as string
  const ideyaInternalApiUrl = import.meta.env
    .VITE_IDEYA_INTERNAL_API_URL as string

  const internalRegex = /^internal(-[a-zA-Z0-9]+)?\.polymerideya\.com$/

  // Dev mode
  if (internalRegex.test(window.location.hostname) && ideyaInternalApiUrl) {
    return ideyaInternalApiUrl
  }

  return ideyaApiUrl
}

export function getBaseQuery(
  baseUrl: string
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  return async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: baseUrl,
      credentials: 'include',
      prepareHeaders: (headers) => {
        const token = getLocalStorageItem('accessToken')
        if (token) {
          headers.set('Authorization', `Bearer ${token}`)
        }
        headers.set('Content-Type', 'application/json')
        return headers
      },
    })

    const result = await baseQuery(args, api, extraOptions)
    if (result.error) {
      if (result.error.status === 'FETCH_ERROR') {
        notification.error({
          message: `Error: Token Expired`,
          description: '',
        })
        // Call cf logout
        //cfLogout();
        return result
      }

      const message = (result.error.data as { message?: string })?.message
      notification.error({
        message: `Error: ${result.error.status}`,
        description: message !== '' ? message : 'An error occurred',
      })
      return result
    }
    return result
  }
}
